import React from "react";
import Form from "./Form";
import { FormattedMessage } from "react-intl";
import { APP_VERSION } from "../../constants";
import AuthLayout from "../../layouts/AuthLayout";

const Login = () => {


  return (
    <div className='w-full h-full flex pr-5 py-5 justify-center items-center bg-gradient-to-tr bg-base-bg'>

      <div className="w-[90%] md:w-3/4 lg:w-1/2">
          <img src="/images/influencee.png" className='mx-auto w-[150px] pb-5 ' />
        <div className=" w-[90%] lg:w-[60%] mx-auto px-4 pt-16 pb-10 shadow-xl bg-content-bg md:rounded-[20px]">
          <h1 className='text-3xl font-bold text-center text-t-light'>
            <FormattedMessage id="login" defaultMessage={"Login"} />
          </h1>
          {
            <p className='text-center text-sm text-t-light w-[90%] mx-auto'>
              <FormattedMessage id="login_description" defaultMessage={"Welcome back and login below."} />
            </p>
          }
          <Form />
        </div>
      </div>

    </div>
  );
};

export default Login;
